export default ({ app }, inject) => {

  // dataAtr - значение data-b24-form
  // dataSkipMoving - значение data-skip-moving'
  // el - элемент перед которым вставляется скрипт
  // url - url скрипта формы b24

  inject('initCrmForm', (dataAtr, dataSkipMoving = 'true', el, url) => {

    // создаем элемент script с указанными атрибутами перед el
    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('data-b24-form', dataAtr)
    scriptEl.setAttribute('data-skip-moving', dataSkipMoving)
    el.insertAdjacentElement('beforeBegin', scriptEl);

    //функция crm формы
    (function(w,d,u){
      var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
      var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
    })(window,document,url)
  })
}
